<ng-container *transloco="let t">
  <div
    class="z-combo-box"
    [class.is-readonly]="readonly"
    [class.is-disabled]="readonly"
    [class.with-popup-only]="popupOnly"
    [class.with-popup-list]="popupList"
    [class.with-dropdown-list]="!popupOnly"
    [class.with-multi-select]="dropdownAllowMultipleValues"
    [class.with-label]="!!label"
    [class.with-hint]="!!hint"
    [class.has-value]="hasValue$ | async"
    [ngClass]="styleClass"
  >
    <z-loading-overlay *ngIf="popupList || popupOnly" [target]="blockId + '-button'" [blocked]="loading">
      <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
    </z-loading-overlay>

    <z-loading-overlay
      *ngIf="!popupList && !popupOnly && dropdownAllowMultipleValues"
      [target]="blockId + '-multi-select'"
      [blocked]="loading"
    >
      <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
    </z-loading-overlay>

    <z-loading-overlay
      *ngIf="!popupList && !popupOnly && !dropdownAllowMultipleValues"
      [target]="blockId + '-dropdown'"
      [blocked]="loading"
    >
      <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
    </z-loading-overlay>

    <label *ngIf="!!label && !hideLabel" [for]="id">
      {{ label }}
    </label>

    <div class="p-inputgroup relative" [class.z-combo-box-multi]="dropdownAllowMultipleValues" [formGroup]="formGroup.form">
      <input
        #input
        *ngIf="popupOnly"
        zTextInput
        [id]="id"
        [formControlName]="fieldName"
        [readonly]="true"
        [placeholder]="placeholder"
        [class.p-disabled]="readonly || disabled"
        [uppercase]="uppercase"
        [displayValidationErrors]="false"
      />

      <p-multiSelect
        #multiSelect
        *ngIf="!popupOnly && dropdownAllowMultipleValues"
        appendTo="body"
        [filter]="dropdownFilter"
        [filterBy]="dropdownFilterBy"
        [formControlName]="fieldName"
        [inputId]="id"
        [optionLabel]="dropdownOptionLabelColumn"
        [options]="list"
        [optionValue]="dropdownOptionValueColumn"
        [panelStyle]="dropdownPanelMinWidthStyle"
        panelStyleClass="z-combo-box z-combo-box-multi virtualDropdownFixedWidth"
        [placeholder]="placeholder"
        [readonly]="readonly || disabled"
        [scrollHeight]="dropdownPanelHeight$ | async"
        [selectionLimit]="selectionLimit"
        [showHeader]="dropdownFilter"
        [showToggleAll]="showToggleAll"
        [styleClass]="blockId + '-multi-select'"
        [virtualScroll]="virtualScroll"
        [virtualScrollItemSize]="dropdownItemSize"
        [class.p-disabled]="readonly || disabled"
        (onClick)="onClick($event)"
        (onFocus)="onFocus($event)"
        (onBlur)="onBlur($event)"
        (onPanelShow)="onMultiSelectPanelShow($event)"
        (onPanelHide)="onMultiSelectPanelHide($event)"
        (onFilter)="onFilterMultiSelect($event)"
        (onChange)="onChange($event)"
      >
        <ng-template let-value pTemplate="selectedItems">
          <span class="selected-items" [pTooltip]="tooltipValue$ | async" tooltipPosition="bottom" [showDelay]="500">
            <!-- value can be an array or a string -->
            <ng-container *ngIf="(value | typeof) === 'object'">
              <ng-container *ngFor="let item of value; let i = index">
                <span class="multi-select-label">{{ item }}<ng-container *ngIf="i < value.length - 1">, </ng-container></span>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="(value | typeof) === 'string'">
              <ng-container *ngFor="let item of value.split(','); let i = index">
                <span class="multi-select-label">{{ item }}<ng-container *ngIf="i < value.split(',').length - 1">, </ng-container></span>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!value || value.length === 0">
              {{ placeholder }}
            </ng-container>
          </span>
        </ng-template>

        <ng-template let-data pTemplate="item">
          <span class="dropdown-item">
            <span [class]="columnsConfig.column1.dropdown.class" *ngIf="columnsConfig.column1.dropdown.display">
              {{ data[columnsConfig.column1.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column2.dropdown.class" *ngIf="columnsConfig.column2.dropdown.display">
              {{ data[columnsConfig.column2.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column3.dropdown.class" *ngIf="columnsConfig.column3.dropdown.display">
              {{ data[columnsConfig.column3.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column4.dropdown.class" *ngIf="columnsConfig.column4.dropdown.display">
              {{ data[columnsConfig.column4.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column5.dropdown.class" *ngIf="columnsConfig.column5.dropdown.display">
              {{ data[columnsConfig.column5.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column6.dropdown.class" *ngIf="columnsConfig.column6.dropdown.display">
              {{ data[columnsConfig.column6.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column7.dropdown.class" *ngIf="columnsConfig.column7.dropdown.display">
              {{ data[columnsConfig.column7.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column8.dropdown.class" *ngIf="columnsConfig.column8.dropdown.display">
              {{ data[columnsConfig.column8.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column9.dropdown.class" *ngIf="columnsConfig.column9.dropdown.display">
              {{ data[columnsConfig.column9.dropdown.key] }}
            </span>

            <span [class]="columnsConfig.column10.dropdown.class" *ngIf="columnsConfig.column10.dropdown.display">
              {{ data[columnsConfig.column10.dropdown.key] }}
            </span>
          </span>
        </ng-template>
      </p-multiSelect>

      <z-clear-button
        *ngIf="!popupOnly && dropdownAllowMultipleValues && clearButton && !readonly"
        (click)="onMultiSelectClear($event)"
      ></z-clear-button>

      <p-dropdown
        #dropdown
        *ngIf="!popupOnly && !dropdownAllowMultipleValues"
        appendTo="body"
        [autoDisplayFirst]="false"
        [filter]="dropdownFilter"
        [filterBy]="dropdownFilterBy"
        [editable]="editable"
        [formControlName]="fieldName"
        [inputId]="id"
        [optionLabel]="dropdownOptionLabelColumn"
        [options]="list"
        [optionValue]="dropdownOptionValueColumn"
        [panelStyle]="dropdownPanelMinWidthStyle"
        panelStyleClass="z-combo-box"
        [placeholder]="placeholder"
        [readonly]="readonly || disabled"
        [scrollHeight]="dropdownPanelHeight$ | async"
        [showClear]="clearButton && !readonly"
        [styleClass]="blockId + '-dropdown' + dropdownStyleClass"
        [virtualScroll]="virtualScroll"
        [virtualScrollItemSize]="dropdownItemSize"
        [class.p-disabled]="readonly || disabled"
        (onClick)="onClick($event)"
        (onFocus)="onFocus($event)"
        (onBlur)="onBlur($event)"
        (onShow)="onDropDownPanelShow($event)"
        (onHide)="onDropDownPanelHide($event)"
        (onClear)="onClear($event)"
        (onFilter)="onFilterDropdown($event)"
        (onChange)="onChange($event)"
      >
        <ng-template let-data pTemplate="selectedItem">
          <span class="selected-item" [pTooltip]="data[selectedItemDescriptionColumn]" tooltipPosition="bottom" [showDelay]="500">
            <span class="label">{{ data[selectedItemLabelColumn] }}</span>
            <span class="description" *ngIf="selectedItemShowDescription"> ({{ data[selectedItemDescriptionColumn] }})</span>
          </span>
        </ng-template>

        <ng-template let-data pTemplate="item">
          <span class="dropdown-item">
            <span
              [class]="columnsConfig.column1.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column1, data[columnsConfig.column1.dropdown.key])"
              *ngIf="columnsConfig.column1.dropdown.display"
            >
              {{ data[columnsConfig.column1.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column1.dropdown.showDescription && data[columnsConfig.column1.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column1.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column2.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column2, data[columnsConfig.column2.dropdown.key])"
              *ngIf="columnsConfig.column2.dropdown.display"
            >
              {{ data[columnsConfig.column2.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column2.dropdown.showDescription && data[columnsConfig.column2.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column2.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column3.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column3, data[columnsConfig.column3.dropdown.key])"
              *ngIf="columnsConfig.column3.dropdown.display"
            >
              {{ data[columnsConfig.column3.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column3.dropdown.showDescription && data[columnsConfig.column3.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column3.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column4.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column4, data[columnsConfig.column4.dropdown.key])"
              *ngIf="columnsConfig.column4.dropdown.display"
            >
              {{ data[columnsConfig.column4.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column4.dropdown.showDescription && data[columnsConfig.column4.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column4.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column5.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column5, data[columnsConfig.column5.dropdown.key])"
              *ngIf="columnsConfig.column5.dropdown.display"
            >
              {{ data[columnsConfig.column5.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column5.dropdown.showDescription && data[columnsConfig.column5.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column5.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column6.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column6, data[columnsConfig.column6.dropdown.key])"
              *ngIf="columnsConfig.column6.dropdown.display"
            >
              {{ data[columnsConfig.column6.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column6.dropdown.showDescription && data[columnsConfig.column6.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column6.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column7.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column7, data[columnsConfig.column7.dropdown.key])"
              *ngIf="columnsConfig.column7.dropdown.display"
            >
              {{ data[columnsConfig.column7.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column7.dropdown.showDescription && data[columnsConfig.column7.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column7.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column8.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column8, data[columnsConfig.column8.dropdown.key])"
              *ngIf="columnsConfig.column8.dropdown.display"
            >
              {{ data[columnsConfig.column8.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column8.dropdown.showDescription && data[columnsConfig.column8.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column8.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column9.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column9, data[columnsConfig.column9.dropdown.key])"
              *ngIf="columnsConfig.column9.dropdown.display"
            >
              {{ data[columnsConfig.column9.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column9.dropdown.showDescription && data[columnsConfig.column9.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column9.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>

            <span
              [class]="columnsConfig.column10.dropdown.class"
              [ngClass]="conditionalDropdownStyleClass(columnsConfig.column1, data[columnsConfig.column10.dropdown.key])"
              *ngIf="columnsConfig.column10.dropdown.display"
            >
              {{ data[columnsConfig.column10.dropdown.key] }}
              <ng-container *ngIf="columnsConfig.column10.dropdown.showDescription && data[columnsConfig.column10.dropdown.key + '_desc']">
                <br /><span class="dropdown-item-description">{{ data[columnsConfig.column10.dropdown.key + '_desc'] }}</span>
              </ng-container>
            </span>
          </span>
        </ng-template>
      </p-dropdown>

      <button
        *ngIf="popupList && !readonly"
        pButton
        type="button"
        icon="fa fa-magnifying-glass"
        class="p-button-outlined p-button-secondary"
        [class]="blockId + '-button'"
        [disabled]="disabled || readonly"
        [class.p-disabled]="disabled"
        (click)="openPopupList()"
        pTooltip="{{ t('core.components.combo_box.open_popup_tooltip') }}"
        tooltipPosition="bottom"
        [showDelay]="500"
      ></button>
    </div>

    <z-hint *ngIf="!!hint" [text]="hint"></z-hint>

    <z-validation *ngIf="displayValidationErrors" [control]="this.formGroup.form.controls[this.fieldName]"></z-validation>

    <p-dialog
      #dialog
      [modal]="true"
      [dismissableMask]="false"
      [draggable]="false"
      [resizable]="false"
      [visible]="display$ | async"
      [styleClass]="popupStyleClass"
      [formGroup]="form"
      appendTo="body"
      *ngIf="popupList && !readonly"
      (visibleChange)="closePopupList()"
      (onShow)="onDialogShow($event)"
      (onHide)="onDialogHide($event)"
      (onResizeInit)="onDialogResizeInit($event)"
      (onResizeEnd)="onDialogResizeEnd($event)"
      (onDragEnd)="onDialogDragEnd($event)"
      (onMaximize)="onDialogMaximize($event)"
    >
      <p-header><i class="mr-1" [class]="popupWindowIcon"></i> {{ popupWindowTitle }}</p-header>

      <p-listbox
        #listbox
        styleClass="z-combo-box-listbox z-listbox z-listbox-small"
        [filter]="popupFilter"
        filterPlaceHolder="{{ t('core.components.combo_box.filter_placeholder') }}"
        formControlName="value"
        [listStyle]="listHeight$ | async"
        [checkbox]="popupAllowMultipleValues"
        [multiple]="popupAllowMultipleValues"
        optionDisabled="disabled"
        [optionLabel]="popupOptionLabelColumn"
        [options]="list"
        [optionValue]="popupOptionValueColumn"
        [showToggleAll]="showToggleAll"
        (onChange)="onListboxChange($event)"
        (onClick)="onListboxClick($event)"
        (onDblClick)="onListboxDblClick($event)"
      >
        <ng-template let-data pTemplate="item">
          <span [class]="columnsConfig.column1.popup.class" *ngIf="columnsConfig.column1.popup.display">
            {{ data[columnsConfig.column1.popup.key] }}
          </span>

          <span [class]="columnsConfig.column2.popup.class" *ngIf="columnsConfig.column2.popup.display">
            {{ data[columnsConfig.column2.popup.key] }}
          </span>

          <span [class]="columnsConfig.column3.popup.class" *ngIf="columnsConfig.column3.popup.display">
            {{ data[columnsConfig.column3.popup.key] }}
          </span>

          <span [class]="columnsConfig.column4.popup.class" *ngIf="columnsConfig.column4.popup.display">
            {{ data[columnsConfig.column4.popup.key] }}
          </span>

          <span [class]="columnsConfig.column5.popup.class" *ngIf="columnsConfig.column5.popup.display">
            {{ data[columnsConfig.column5.popup.key] }}
          </span>

          <span [class]="columnsConfig.column6.popup.class" *ngIf="columnsConfig.column6.popup.display">
            {{ data[columnsConfig.column6.popup.key] }}
          </span>

          <span [class]="columnsConfig.column7.popup.class" *ngIf="columnsConfig.column7.popup.display">
            {{ data[columnsConfig.column7.popup.key] }}
          </span>

          <span [class]="columnsConfig.column8.popup.class" *ngIf="columnsConfig.column8.popup.display">
            {{ data[columnsConfig.column8.popup.key] }}
          </span>

          <span [class]="columnsConfig.column9.popup.class" *ngIf="columnsConfig.column9.popup.display">
            {{ data[columnsConfig.column9.popup.key] }}
          </span>

          <span [class]="columnsConfig.column10.popup.class" *ngIf="columnsConfig.column10.popup.display">
            {{ data[columnsConfig.column10.popup.key] }}
          </span>
        </ng-template>
      </p-listbox>

      <p-footer>
        <p-button [icon]="selectButtonIcon" (click)="selectValue()" [label]="selectButtonLabel" [styleClass]="selectButtonClass"></p-button>

        <p-button
          (click)="closePopupList()"
          [icon]="cancelButtonIcon"
          [label]="cancelButtonLabel"
          [styleClass]="cancelButtonClass"
        ></p-button>
      </p-footer>
    </p-dialog>
  </div>
</ng-container>
